










































import { computed, defineComponent, PropType, ref, toRef, watch } from "@vue/composition-api";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { TagInfo } from "@scrile/api-provider/dist/api/TagsProvider";
import { UserLocation } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import { ContentFeedSearchResult } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import useAuthUser from "@/hooks/useAuthUser";
import { $t } from "@/lib/i18nHelpers";
import config from "@/config";
import { TabField } from "@/types";
import BaseIcon from "@/components/BaseIcon";
import BasePage from "@/components/BasePage";
import ConfirmSensitiveContent from "@/components/ConfirmSensitiveContent";
import ContentFeedView from "@/components/ContentFeedView";
import CreatorsSlider from "@/components/CreatorsSlider";
import EmptyContent from "@/components/EmptyContent";
import FeedNsfwNotice from "@/components/FeedNsfwNotice";
import LivesWidget from "@/components/LivesWidget";
import PageTitle from "@/components/PageTitle";
import TabsHeader from "@/components/TabsHeader";
import DiscoverFilters from "../DiscoverFilters";

export default defineComponent({
  name: "DiscoverView",
  components: {
    LivesWidget,
    FeedNsfwNotice,
    DiscoverFilters,
    BaseIcon,
    BasePage,
    ConfirmSensitiveContent,
    ContentFeedView,
    CreatorsSlider,
    EmptyContent,
    PageTitle,
    TabsHeader,
  },
  props: {
    onFeed: { type: Boolean, required: true },
    loading: { type: Boolean, required: true },
    enableScroll: { type: Boolean, required: true },
    selectedTags: { type: Array as () => TagInfo[], required: true },
    tagIds: { type: Array as PropType<string[]>, default: () => [] },
    hashtagIds: { type: Array as PropType<string[]>, default: () => [] },
    languages: { type: Array as PropType<string[]>, default: () => [] },
    locations: { type: Array as PropType<UserLocation[]>, default: () => [] },
    selectedSort: { type: String, default: "random" },
    followedUserIds: { type: Object as () => Record<string, boolean>, required: true },
    contentFeedSearchResult: { type: Object as () => ContentFeedSearchResult | null },
    paymentPackages: { type: Array as () => PaymentPackage[], required: true },
  },
  setup(props, { root }) {
    const { authUser } = useAuthUser();
    const feedId = ref<string | null>(null);
    const showCreatorsSlider = computed(() => config.featureDiscoveryCreators);
    const emptyDiscover = computed(() => {
      return !props.loading && props.contentFeedSearchResult?.result.length === 0;
    });

    const tabs = computed(() => {
      const list: TabField[] = [
        {
          name: "home",
          text: $t("Home"),
          to: { name: "home" },
        },
        {
          name: "discover",
          text: $t("Discover"),
          to: { name: "discover" },
        },
      ];
      return (authUser.value && list) || list.filter(i => i.name !== "home");
    });

    const openFeed = (openFeedId: string) => {
      feedId.value = openFeedId;
      root.$router.push({
        name: "discoverFeed",
        query: root.$route.query,
      });
    };

    const onGoLive = (roomId: string) => {
      root.$router.push({ name: "discoverFeedLiveByRoomId", params: { roomId } });
    };

    watch(
      toRef(props, "onFeed"),
      newValue => {
        if (!newValue && feedId.value) {
          feedId.value = null;
        }
      },
      { immediate: true }
    );
    watch(
      toRef(props, "contentFeedSearchResult"),
      (newValue, oldValue) => {
        if (!oldValue && newValue && feedId.value === null && props.onFeed) {
          feedId.value = newValue.result.find(() => true)?.id ?? null;
        }
      },
      { immediate: true }
    );

    return {
      feedId,
      showCreatorsSlider,
      tabs,
      emptyDiscover,
      openFeed,
      onGoLive,
    };
  },
});
